<template lang="pug">
    div
        Modal(
            title="Connect to your node"
            v-model="isModalShow"
            width="400"
            @on-visible-change="handleOnVisibleChange"
        )
            Form(:model="nodeConnectForm" :rules="cloudFormValidate" ref="nodeConnectForm")
                FormItem(label="Machine Hostname" prop="hostname")
                    Input(v-model="nodeConnectForm.hostname" style="width: 180px" size="small" disabled)
                FormItem(label="SSH HOST" prop="sshHost")
                    Input(v-model="nodeConnectForm.sshHost" style="width: 180px" size="small")
                FormItem(label="SSH PORT" prop="sshPort")
                    InputNumber(v-model="nodeConnectForm.sshPort" style="width: 180px" size="small")
                FormItem(label="SSH USER" prop="sshUser")
                    Input(v-model="nodeConnectForm.sshUser" style="width: 180px" size="small")
                ExplainPrivateKeys
                FormItem(label="SSH AUTH METHOD" prop="sshAuthMethod")
                    RadioGroup(v-model="nodeConnectForm.sshAuthMethod" vertical)
                        // Radio(label="t3.small")
                        Radio(label="privateKey")
                            span PRIVATE KEY
                        Radio(label="password")
                            span PASSWORD
                FormItem(label="SSH KEY" prop="sshKeyName" v-if="nodeConnectForm.sshAuthMethod == 'privateKey'")
                    FormSelect(
                        v-model="nodeConnectForm.sshKeyName" 
                        :formData="nodeConnectForm" 
                        :formItem="sshKeySelectorOptions" 
                        style="width: 250px")
                FormItem(label="SSH PASSWORD" prop="sshPassword" v-else)
                    Input(
                        v-model="nodeConnectForm.sshPassword" 
                        style="width: 180px" 
                        size="small"
                        type="password"
                        password
                    )
            div(slot="footer")
                Button(@click="startConnect" type="primary" long) Connect

        Button(@click="showConnectModal" size="small")
            Icon(type="md-browsers")

</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import { buildQueryString } from "@/libs/utils";
import ExplainPrivateKeys from "@/components/PoptipInfos/ExplainPrivateKeys"

export default {
    name: "NodeConnectBtn",
    props: {
        nodeType: { type: String, default: "" },
        hostname: { type: String, default: "" },
        sshKeyName: { type: String, default: "default" },
        sshHost: { type: String, default: "" },
        sshPort: { type: Number, default: 22 },
        sshUser: { type: String, default: "ubuntu" },
    },
    components: { FormSelect, ExplainPrivateKeys },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            isModalShow: false,
            nodeConnectForm: {},
            cloudFormValidate: {
                nodeType: [
                    {
                        required: true,
                        message: `missing nodeType`,
                        trigger: "blur",
                    },
                ],
                hostname: [
                    {
                        required: true,
                        message: `missing hostname`,
                        trigger: "blur",
                    },
                ],
                sshKeyName: [
                    {
                        required: true,
                        message: `missing sshKeyName`,
                        trigger: "blur",
                    },
                ],
                sshHost: [
                    {
                        required: true,
                        message: `missing sshHost`,
                        trigger: "blur",
                    },
                ],
                sshPort: [
                    {
                        required: true,
                        type: "number",
                        message: `missing sshPort`,
                        trigger: "blur",
                    },
                ],
                sshUser: [
                    {
                        required: true,
                        message: `missing sshUser`,
                        trigger: "blur",
                    },
                ],
            },
            sshKeySelectorOptions: {
                placeholder: "PRIVATE KEY",
                options: [],
                multiple: false,
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.sshKeyName = `*${queryValue}*`;
                    queryParams.withDefault = true;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/sshkeynames?${queryString}`);
                    return result.data.options;
                },
                // queryParamsFields: [{ fieldName: "groupName", queryIf: val => val !== "" }],
                defaultVal: "",
            },
        };
    },
    methods: {
        showConnectModal() {
            this.nodeConnectForm = {
                nodeType: this.nodeType,
                hostname: this.hostname,
                sshKeyName: this.sshKeyName,
                sshHost: this.sshHost,
                sshPort: this.sshPort,
                sshUser: this.sshUser,
                sshPassword: "",
                sshAuthMethod: "privateKey",
            };
            this.isModalShow = true;
        },
        startConnect() {
            this.$refs.nodeConnectForm.validate((valid) => {
                if (!valid) return this.$Message.error(this.$t("rcmtable.formErrorMsg"));
                let {
                    nodeType,
                    hostname,
                    sshKeyName,
                    sshUser,
                    sshHost,
                    sshPort,
                    sshAuthMethod,
                    sshPassword,
                } = this.nodeConnectForm;
                let params = Object.assign({}, this.nodeConnectForm);
                params.sshPassword = Buffer.from(params.sshPassword).toString("base64");
                params.groupName = this.$store.state.queryGroupName;
                let queryString = buildQueryString(params);

                window.open(`/system-manage/nodes-connect?${queryString}`, "_blank");
            });
        },
        handleOnVisibleChange(visible) {
            if (!visible) {
                console.log("HANDLE CLOSE");
                this.$refs.nodeConnectForm.resetFields();
                this.isModalShow = false;
            }
        },
    },
    mounted() {},
    computed: {},
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/NodeConnectBtn.vue